// Auto-generated by tools/scripts/generate-version.mjs — do not edit.
// Regenerated before every build; local values are placeholders.
export const APP_VERSION = '1.0.0-beta.232';
export const APP_COMMIT = '4b301749';
export const APP_BUILD_DATE = '2026-11-04';
